import { Link } from "react-router-dom";
import "../styles/body.css";
import Vedio from "./Vedio";
import { useEffect, useState } from "react";
import { client } from "../api/Client";;

export default function Body() {
  let [vedioData, setVedio] = useState();
  let [loadData, setLoadData] = useState(false);

  useEffect(() => {
    if(loadData === false) {
      client.get("/GetVedios/3")
      .then((res) => {
        setVedio(res.data.Vedios)
        console.log(res.data.Vedios[0])
      })
      .catch(error => {
        alert(error)
      })
      setLoadData(true)
    }
  },[]);

    return <>
    <section className="body" id="body">
      <div className="container-body">
        <div className="container-left">
          <h2>Beto Photography</h2>
          <h4>
            There is photography
            <br />
            1- Weddings, engagements
            <br />
            2- Birthdays, parties
            <br />
            3- A special section: for propaganda and advertising.
            <br />
            4- Activating websites (start-up projects)
            <br />
            5- Photographing children
            <br />
            We have the best Nikon, Canon, Sony equipment.
          </h4>
          <Link to="#Conntect" className="callMe"> Call me </Link>
        </div>
        <div className="container-right">
          { vedioData?.map(item => {
            return (
              <Vedio linkVedio={ item.VedioURL } />
            );
          }) }
        </div>
      </div>
      <script async="" src="https://www.tiktok.com/embed.js"></script>
    </section>
    </>;  
};